// extracted by mini-css-extract-plugin
export var left = "Footer-module--left--WKHzP";
export var logo = "Footer-module--logo--FvZvE";
export var right = "Footer-module--right--Om28S";
export var root = "Footer-module--root--d9RCn";
export var socialMedia = "Footer-module--socialMedia--jCoHG";